<template>
  <div class="sp-template">
    <div class="h-title">在库订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="conditions.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户">
              <el-select v-model.lazy="conditions.orgOwner" filterable clearable multiple>
                <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input v-model="conditions.numberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
            <div v-show="isSearchMore">
              <el-row>
                <el-form-item label="订单状态">
                  <el-select v-model.lazy="conditions.stages" clearable>
                    <el-option v-for="(d, i) in tmsOrderStages" :key="i" :label="'已'+d.name" :value="d.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="产品">
                  <el-select v-model="conditions.product" filterable clearable multiple>
                    <el-option v-for="(d, i) in channelDatas" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="客户订单号">
                  <el-input v-model="conditions.customerOrderNumberTextArea" type="textarea" placeholder="多个单号用回车分割"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="入仓日期">
                  <div class="datepicker-content">
                    <el-date-picker v-model="conditions.receiptStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 160px;"></el-date-picker>
                    <div class="divide">至</div>
                    <el-date-picker v-model="conditions.receiptEndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 160px;"></el-date-picker>
                  </div>
                </el-form-item>
              </el-row>
              <el-row v-show="conditions.status == '出仓'">
                <el-form-item label="出仓日期">
                  <div class="datepicker-content">
                    <el-date-picker v-model="conditions.shippingStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width: 160px;"></el-date-picker>
                    <div class="divide">至</div>
                    <el-date-picker v-model="conditions.shippingEndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" style="width: 160px;"></el-date-picker>
                  </div>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="过滤条件">
                  <el-checkbox v-model="conditions.detainGoods">扣货订单</el-checkbox>
                  <el-checkbox v-model="conditions.isNormal">是否异常</el-checkbox>
                </el-form-item>
              </el-row>
            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(101)" size="small" type="primary" @click="search">搜索</el-button>
            <el-button size="small" @click="reset">清空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="search">
					<el-tab-pane label="在仓" name="在仓"></el-tab-pane>
					<el-tab-pane label="出仓" name="出仓"></el-tab-pane>
				</el-tabs>
      </div>
      <el-table ref="multipleTable" :data="tableData" border stripe tooltip-effect="dark" style="width: 100%" max-height="800" v-loading="loading" element-loading-text="拼命加载中，请稍候">
        <el-table-column prop="orderId" label="订单号" width="150"></el-table-column>
        <el-table-column label="客户/客户订单号" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.customerName !== null">
              <span class="name-tooltips first">客</span>{{scope.row.customerName}}</div>
            <div v-if="scope.row.customerOrderNumber !== null">
              <span class="name-tooltips second">号</span>{{scope.row.customerOrderNumber}}</div>
            <!-- <div>
              <span v-if="scope.row.overWeight" class="name-tooltips third" style="background:red">超重</span>
              <span v-if="scope.row.overSize" class="name-tooltips third" style="background:red">超长</span>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.warehouseId]}}
            </template>
        </el-table-column>
        <el-table-column prop="receiptTime" label="入仓日期"></el-table-column>
        <el-table-column prop="productName" label="产品"></el-table-column>
        <el-table-column prop="totalCarton" label="货物箱数"></el-table-column>
        <el-table-column prop="currentStatus" label="当前状态"></el-table-column>
        <el-table-column prop="nextStatus" label="下一状态"></el-table-column>
        <el-table-column prop="shippingTime" label="出仓日期"></el-table-column>
        <el-table-column label="扣货状态">
          <template slot-scope="scope">
            {{scope.row.detainGoods ? "是":"否"}}
          </template>
        </el-table-column>
        <el-table-column label="是否异常">
          <template slot-scope="scope">
            {{scope.row.exception || scope.row.nonSysException ? "是":"否"}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      isSearchMore: false,
      warehouses:[],
      warehouseMap: {},
      conditions: {
        warehouseIds: [],
        status: "在仓",
        stages: "",
        orgOwner: [],
        product: [],
        receiptStartTime: "",
        receiptEndTime: "",
        shippingStartTime: "",
        shippingEndTime: "",
        currentPage: 1,
        pageSize: 10,
        detainGoods: false,
        isNormal: false,
        numberTextArea: "",
        customerOrderNumberTextArea: ""
      },
      total: 0,
      tableData: [],
      tmsOrderStages: [],
      customerList: [],
      channelDatas: []
    };
  },
  watch: {
    "conditions.status"() {
      this.conditions.stages = "";
      this.conditions.shippingStartTime = "";
      this.conditions.shippingEndTime = "";
    }
  },
  created() {
    setTimeout(() => {
      this.loadTmsOrderStages();
      this.findByCustomerName();
      this.findAllChannle();

      // 仓库加载后加载订单
      this.queryWarehouseList();
      
      this.loading = false;
    }, 1000);
  },
  methods: {
    // 清空搜索条件
    reset() {
      this.conditions = {
        status: "在仓",
        stages: "",
        orgOwner: [],
        product: [],
        inDate: "",
        outDate: "",
        currentPage: 1,
        pageSize: 10,
        detainGoods: false,
        isNormal: false,
        numberTextArea: "",
        customerOrderNumberTextArea: ""
      };
      this.onSubmit();
    },
    search() {
      this.conditions.currentPage = 1;
      this.loadTmsOrderStages();
      this.onSubmit();
    },
    queryWarehouseList(){
        let _this = this;
        _this.$request1
        .get(
          '/warehouse/staff',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.warehouses = res.data;
          _this.warehouses.forEach(a => {
                _this.warehouseMap[a.id] = a.name;
            });

            _this.onSubmit();
        })
        .catch(function(error) {
          console.log(error);
        });
        
    },
    onSubmit() {
      let _this = this;
      let orderIds = [];
      _this.conditions.numberTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          orderIds.push(d);
        }
      });
      let customerOrderNumber = [];
      _this.conditions.customerOrderNumberTextArea
        .split(/\n+/gim)
        .forEach((d, i) => {
          if (d && d != "") {
            customerOrderNumber.push(d);
          }
        });

        //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.conditions.warehouseIds && _this.conditions.warehouseIds.length>0){
                wlist = _this.conditions.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

      _this.$request1({
          method: 'post',
          url: '/warehouse-order/query',
          data: {
            orderIds: orderIds,
            orgOwners: _this.conditions.orgOwner,
            productIds: _this.conditions.product,
            customerOrderNumber: customerOrderNumber,
            detainGoods: _this.conditions.detainGoods,
            exception: _this.conditions.isNormal,
            receipt: _this.conditions.status == "在仓",
            status: _this.conditions.stages,
            receiptStartTime: _this.conditions.receiptStartTime,
            receiptEndTime: _this.conditions.receiptEndTime,
            shippingStartTime: _this.conditions.shippingStartTime,
            shippingEndTime: _this.conditions.shippingEndTime,
            currentPage: _this.conditions.currentPage,
            pageSize: _this.conditions.pageSize,
            warehouseIds: wlist
          }
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.total == 0) {
              _this.total = 0;
              _this.tableData = [];
            }
            _this.total = response.data.total;
            _this.tableData = response.data.data;
          } else {
            _this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          _this.tableData = [];
          _this.total = 0;
          console.log(error);
        });
    },
    loadTmsOrderStages() {
      let _this = this;
      if (_this.conditions.status == "在仓") {
        _this.tmsOrderStages = [
          {
            name: "收货",
            value: "receipt"
          },
          {
            name: "测量",
            value: "measure"
          },
          {
            name: "客户确认发货",
            value: "need_to_confirm"
          },
          {
            name: "运力分配",
            value: "capacity_allocation"
          },
          {
            name: "批次操作",
            value: "batch_operation"
          }
        ];
      } else {
        _this.tmsOrderStages = [
          {
            name: "出货",
            value: "shipping"
          },
          {
            name: "末端派送",
            value: "origin_scan"
          },
          {
            name: "签收",
            value: "delivery"
          }
        ];
      }
    },
    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customer/filter',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customerList = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    findAllChannle() {
      this.$request1({
        method: 'GET',
        url: '/system/channel/all'
      })
        .then(response => {
          this.channelDatas = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.onSubmit();
    }
  }
};
</script>

<style lang="scss" scoped>
.button-groups {
  text-align: right;
}
.datepicker-content {
  display: flex;
  align-items: center;
  .divide {
    margin: 0 10px;
  }
  .el-card__header .el-form .el-input {
    width: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/instock/instock.vue